import { LoadingButton } from '@mui/lab';
import { DialogTitle, FormControl, TextField } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import useCreatePartNode from 'api/locationsCategories/useCreatePartNode';
import { useForm } from 'react-hook-form';

import { partFieldValidationValues } from '../constants';

const CreatePartNodeModal = props => {
  const { guid } = props;

  const [createLoading, createPartNode] = useCreatePartNode();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitted },
  } = useForm({
    defaultValues: {
      name: '',
    },
  });

  const onSubmit = data => {
    createPartNode(guid, data.name, props.refreshData);
  };

  const handleClose = () => {
    props.closeHandler();
    reset();
  };

  return (
    <Dialog
      open={props.show}
      onClose={handleClose}
      sx={{ direction: 'rtl' }}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          handleSubmit(onSubmit)();
        }
      }}
    >
      <DialogTitle>افزودن بخش</DialogTitle>

      <DialogContent>
        <FormControl sx={{ m: 1, minWidth: 300 }}>
          <TextField
            autoFocus
            label="عنوان بخش"
            variant="standard"
            {...register('name', partFieldValidationValues)}
            error={isSubmitted ? !!errors.name : false}
            helperText={errors.name?.message || ''}
          />
        </FormControl>
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <LoadingButton
          variant="contained"
          color="primary"
          loading={createLoading}
          onClick={handleSubmit(onSubmit)}
        >
          تایید
        </LoadingButton>

        <LoadingButton
          variant="contained"
          color="warning"
          loading={createLoading}
          onClick={handleClose}
        >
          انصراف
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default CreatePartNodeModal;
